<template>
    <div class="toast" v-show="isshow" >{{msg}}</div>
</template>
<script>
    export default{
        name:'toast',
        props:{
            msg:{
                type:String
            },
            time:{
                type:Number,
                default:2500
            }
        },
        data(){
            return {
                isshow:false,
                timer:null
            }
        },
        watch:{
            msg(val){
                if(val){
                    clearTimeout(this.timer)
                    this.isshow=true;
                    this.timser=setTimeout(()=>{
                        this.isshow=false;
                        this.$parent.msg='';
                    },this.time)
                }
                
            }
        }
    }
</script>
<style lang="scss">
    .toast{
        position: fixed;
        padding:.05rem .3rem;
        box-sizing: border-box;
        max-width: 80%;
        line-height: 2;
        @extend .bg;
        left:50%;
        top:50%;
        transform: translate(-50%,-50%);
        transition: 1s;
        opacity: 1;
        color:#fff;
        font-size: .24rem;
        @extend .radius;

    }
</style>